import React from "react";
import rill from "rill";
import set from "@rill/set";
import MetricsNav from "../../../parts/metrics-nav";

import getDailyStats from "../calendar/daily-stats.controller";
import defaultQueryDate from "./default-query-date.controller";

import MetricsView from "./metrics";
import Custom from "./custom";
import OverUnderBaseline from "./over-under-baseline";
import VolumeIntensity from "./volume-intensity";
import NumberOfLifts from "./number-of-lifts";
import CoreAccessoryVolumeSplit from "./core-accessory-volume-split";
import BaselineVolumeRelativeIntensity from "./baseline-volume-relative-intensity";
import RecordTable from "./record-table";
import RawEquippedVolumeSplit from "./raw-equipped-volume-split";
import VolumeSplitCoreLift from "./volume-split-core-lift";
import CompetitionHistory from "./competition-history";
import RepMaxEstimator from "./rep-max-estimator";
import RpeTable from "./rpe-table";
import Bodyweight from "../calendar/bodyweight/bodyweight.controller";
import RestingHeartRate from "../calendar/resting-heart-rate/resting-heart-rate.controller";
import SessionRpe from "../calendar/session-rpe-controller";
import ReadinessRate from "../calendar/readiness-rate-controller";
import ProgressPhotos from "../calendar/progress-photos-controller";
import BodyMeasurements from "../calendar/body-measurements-controller";
import ExerciseHistory from "../calendar/exercise-history-controller";
import VideoList from "../calendar/video-list-controller";
import StepCount from "../calendar/step-count/step-count.controller";
import SleepTime from "../calendar/sleep-time/sleep-time.controller";
import WaterIntake from "../calendar/water-intake/water-intake.controller";
import Hrv from "../calendar/hrv/hrv.controller";
import RpeController from "../calendar/rpe-report-controller";
import PersonalRecordController from "../calendar/personal-record-controller";
import AnnualPlannerRedirect from "./annual-planner-redirect";
import BodyFatController from "../calendar/body-fat/body-fat.controller";
import BodyCompositionController from "../calendar/body-composition-controller";
import AccountabilityController from "../calendar/accountability-tracker/accountability.controller";
import CheckInSummaryController from "./check-in-summary/check-in-summary-controller";
import ReportsMenuController from "./reports-menu-controller";
import BlockReviewController from "./block-review/block-review-controller";
import MealPhotosController from "./meal-photos/meal-photos-controller";
import MenstrualCycleController from "../calendar/menstrual-cycle/menstrual-cycle.controller";

const Metrics = (app) => {
  app.at(
    "/metrics/*",
    rill()
      .use(set("heading", ["Athlete", <MetricsNav />]))
      .setup(defaultQueryDate)
      .setup(getDailyStats)
      .setup(MetricsView)
      .setup(Custom)
      .setup(OverUnderBaseline)
      .setup(VolumeIntensity)
      .setup(NumberOfLifts)
      .setup(CoreAccessoryVolumeSplit)
      .setup(BaselineVolumeRelativeIntensity)
      .setup(RecordTable)
      .setup(RawEquippedVolumeSplit)
      .setup(VolumeSplitCoreLift)
      .setup(CompetitionHistory)
      .setup(RepMaxEstimator)
      .setup(RpeTable)
      .setup(Bodyweight)
      .setup(RestingHeartRate)
      .setup(SessionRpe)
      .setup(ReadinessRate)
      .setup(ReportsMenuController)
      .setup(ProgressPhotos)
      .setup(BodyMeasurements)
      .setup(ExerciseHistory)
      .setup(VideoList)
      .setup(StepCount)
      .setup(SleepTime)
      .setup(WaterIntake)
      .setup(Hrv)
      .setup(RpeController)
      .setup(PersonalRecordController)
      .setup(BodyFatController)
      .setup(BodyCompositionController)
      .setup(AnnualPlannerRedirect)
      .setup(AccountabilityController)
      .setup(CheckInSummaryController)
      .setup(BlockReviewController)
      .setup(MealPhotosController)
      .setup(MenstrualCycleController)
  );
};

export default Metrics;
